import QuickActionListModule from './QuickActionList.module';

export default QuickActionListModule;
